import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

export default function MaterialIcon({ icon, className, ...props }) {
  return (
    <i className={cx(className, 'material-icons')} {...props}>
      {icon}
    </i>
  )
}

MaterialIcon.propTypes = {
  className: PropTypes.string,
  icon: PropTypes.string,
}
